import { DEFAULT_PRICE_COUNTRY } from '@hub/libs/constants';

export const getSessionPayload = (locale: string): { language: string; country: string } => {
  return {
    language:
      locale.split('-')[1]?.toLowerCase() === 'si' || locale.split('-')[1]?.toLowerCase() === 'lv'
        ? 'en'
        : locale.split('-')[0],
    country: locale.split('-')[1] || DEFAULT_PRICE_COUNTRY,
  };
};
